/***************************************************************************

    Copyright (C) 2020 Ravenpod, Inc.
    All rights reserved.

    This material contains CONFIDENTIAL INFORMATION
    that is the property of Ravenpod.com, Inc.
    Any unauthorized use, duplication or disclosure is prohibited.

***************************************************************************/
import NumberHelper from './number_helper'
import ColorScheme from 'color-scheme'

import Color from 'color'
import normalize from 'array-normalize'

const red = '#F44336'
const pink = '#E91E63'
const purple = '#9C27B0'
const deepPurple = '#673AB7'
const indigo = '#3F51B5'
const blue = '#2196F3'
const lightBlue = '#03A9F4'
const cyan = '#00BCD4'
const teal = '#009688'
const green = '#4CAF50'
const lightGreen = '#8BC34A'
const lime = '#CDDC39'
const yellow = '#FFEB3B'
const amber = '#FFC107'
const orange = '#FF9800'
const deepOrange = '#FF5722'
const brown = '#795548'
const blueGrey = '#607D8B'

const colors = [indigo, blue, lightBlue, cyan, teal, brown, blueGrey]

const nodeColors = [pink, purple, deepPurple, indigo, cyan, lime, yellow, amber, orange, deepOrange, brown, blueGrey]

const pinkColors = ['#FCE4EC', '#F8BBD0', '#F48FB1', '#F06292', '#EC407A']

const purpleColors = ['#E1BEE7']

const heatBaseColor = '#EDE7F6'

let randomColorIndex = 0

const funcs = {

    getHeatColorAndText: (samples, value) => {        
        const color = Color(heatBaseColor);
        const index = samples.indexOf(value);
        if (index == -1) {
            const darkenColor = color.darken( 0.5 )
            return { color: darkenColor, text: darkenColor.isDark() ? 'white--text' : '' }    
        } else {
            const normlizedSamples = normalize([...samples]).map( (ele) => { return ele * 0.75 } )
            const darkenColor = color.darken( normlizedSamples[index] )
            return { color: darkenColor, text: darkenColor.isDark() ? 'white--text' : '' }    
        }
    },

    getPinkColors: () => {
        return pinkColors;
    },

    getPurpleColors: () => {
        return purpleColors;
    },

    getColors: () => {
        return colors;
    },

    getRandomColors: () => {
        let colorsClone = [...colors]
        return funcs.randomizeColorsArray(colorsClone)
    },

    resetColorIndex: () => {
        randomColorIndex = 0;
    },

    getNextColorInSeries: () => {        
        const result = colors[randomColorIndex++]
        if (randomColorIndex >= colors.length) {
            randomColorIndex = 0
        }
        return result;
    },

    getSingleRandomColor: () => {
        var lum = -0.25;
        var hex = String('#' + Math.random().toString(16).slice(2, 8).toUpperCase()).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        var rgb = "#",
            c, i;
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += ("00" + c).substr(c.length);
        }
        return rgb;
    },

    randomizeColorsArray: (colorsArray) => {

        var currentIndex = colorsArray.length, temporaryValue, randomIndex;
  
        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
      
          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
      
          // And swap it with the current element.
          temporaryValue = colorsArray[currentIndex];
          colorsArray[currentIndex] = colorsArray[randomIndex];
          colorsArray[randomIndex] = temporaryValue;
        }
      
        return colorsArray;

    }
    
}

export default funcs